const browser = require("../assets/js/browser.min.js");

export default window.browser = browser;
